export default function timePastIssue(timeStamp) {
    var now = new Date(),
    secondsPast = (now.getTime() - timeStamp) / 1000;

    if (secondsPast < 60) {
      return parseInt(secondsPast) + ' seconds ago';
    }

    if (secondsPast < 3600) {
      return parseInt(secondsPast / 60) + ' minutes ago';
    }

    if (secondsPast <= 86400) {
      return parseInt(secondsPast / 3600) + ' hours ago';
    }
    
    if (secondsPast > 86400) {
      const day = timeStamp.getDate();
      const month = timeStamp.toDateString().match(/ [a-zA-Z]*/)[0].replace(" ", "");
      const year = timeStamp.getFullYear() === now.getFullYear() ? "" : " " + timeStamp.getFullYear();
      return 'on ' + day + " " + month + year;
    }
  }